export const createRouteSelectByQuote = async (customerId: string) => {
  const api = $urlPartner.quote.customer
  const data = await $api(api, { uriParams: { customerId } })
  const resData: any = data?.data?.value

  let quotes = [] as { [key: string]: any }[]
  if (resData?.success) {
    quotes = resData.data
  }

  if (!quotes.length) {
    return []
  }

  const results = [] as { [key: string]: any }[]

  quotes.forEach((quote) => {
    results.push(...processQuotePositions(quote))
  })

  return $lodash.sortBy(results, 'idQuoteAndCharge').reverse()
}

export const processQuotePositions = (quote: { [key: string]: any }) => {
  const results = [] as { [key: string]: any }[]

  const positions = getPositions(quote)

  if (Array.isArray(positions)) {
    positions.forEach((position) => {
      const data = $lodash.cloneDeep(quote)

      data.positions = position?.positions
      data.routingPositions = position?.routingPositions
      data.quoteAndRouteName = position?.quoteAndRouteName
      data.charge = position._id
      data.chargeName = position.chargeName
      data.chargesSelect = {
        position
      }
      data.charges = []
      data.priceOfflineFee = []
      data.oldPriceOfflineFee = []

      data.idQuoteAndCharge = data._id + '-' + position._id

      results.push(data)
    })
  }

  return results
}

const getPositions = (quoteData: { [key: string]: any }) => {
  try {
    const internalCharge = quoteData?.charges?.find((item: any) => item.type === 'internal')
    const internalVendor = quoteData?.charges?.find((item: any) => item.type === 'vendor')

    // tuyến chính
    let chargePositions = internalCharge
      ? [
          {
            ...internalCharge,
            routeName: internalCharge?.positions?.map((position: any) => position.nodeLocationName).join(' - '),
            chargeName: internalCharge?.positions?.map((position: any) => position.fullNameNode).join(' >>> '),
            quoteAndRouteName:
              (quoteData.quoteName || '') + ', ' + (internalCharge?.positions?.map((position: any) => position.nodeLocationName).join(' - ') || '')
          }
        ]
      : []

    if (!chargePositions.length && internalVendor) {
      chargePositions = [
        {
          ...internalVendor,
          routingPositions: null,
          routeName: internalVendor?.positions?.map((position: any) => position.nodeLocationName).join(' - '),
          chargeName: internalVendor?.positions?.map((position: any) => position.fullNameNode).join(' >>> '),
          quoteAndRouteName:
            (quoteData.quoteName || '') + ', ' + (internalVendor?.positions?.map((position: any) => position.nodeLocationName).join(' - ') || '')
        }
      ]
    }

    // trái tuyến
    const chargePriceOfflineFee =
      quoteData?.priceOfflineFee?.map((chargeOfflineFee: any) => {
        const routeName = chargeOfflineFee?.positions?.map((position: any) => {
          return position.nodeLocationName
        })
        const chargeName = chargeOfflineFee?.positions?.map((position: any) => {
          return position.fullNameNode
        })
        chargeOfflineFee.routeName = routeName.join(' - ')
        chargeOfflineFee.chargeName = chargeName.join(' >>> ')
        chargeOfflineFee.quoteAndRouteName = (quoteData.quoteName || '') + ', ' + chargeOfflineFee.routeName
        return chargeOfflineFee
      }) || []

    return [...chargePositions, ...chargePriceOfflineFee]
  } catch (e) {
    return []
  }
}

export const nodeLocationNames = (positions: { [key: string]: any }[]) => {
  const names = (positions || []).map((item: any) => item.nodeLocationName)
  return names.join(' - ')
}

export const nodeNames = (positions: { [key: string]: any }[]) => {
  const names = (positions || []).map((item: any) => item.fullNameNode)
  return names.join(' >>> ')
}
